import { updateDefaultMerchant } from "@/repository/api";

/**
 * Initialize default merchant from URL params.
 * If ?merchant={id} is present and user is logged in, sets the default merchant.
 *
 * @param {Object} userStore - The user store instance
 * @returns {Promise<boolean>} - Whether the merchant was set
 */
export const initDefaultMerchantFromUrlParams = async (userStore) => {
  const urlParams = new URLSearchParams(window.location.search);
  const merchantId = urlParams.get('merchant');

  if (merchantId && userStore.loggedIn) {
    const result = await updateDefaultMerchant({ merchantId: parseInt(merchantId) });
    if (result && userStore.user) {
      userStore.user.default_merchant_id = result.default_merchant_id;
    }
    return !!result;
  }

  return false;
};
